import { render, staticRenderFns } from "./CallActive.vue?vue&type=template&id=02f72c08&scoped=true&"
import script from "./CallActive.vue?vue&type=script&lang=js&"
export * from "./CallActive.vue?vue&type=script&lang=js&"
import style0 from "./CallActive.vue?vue&type=style&index=0&id=02f72c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f72c08",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VBtn,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02f72c08')) {
      api.createRecord('02f72c08', component.options)
    } else {
      api.reload('02f72c08', component.options)
    }
    module.hot.accept("./CallActive.vue?vue&type=template&id=02f72c08&scoped=true&", function () {
      api.rerender('02f72c08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/phone/components/CallActive.vue"
export default component.exports